import React from 'react'
import { Card } from 'react-bootstrap'

export default function SimpleCard({
  children,
  className,
  title,
  header,
  style,
}: {
  children: any
  className?: string
  title?: string | JSX.Element
  header?: string | JSX.Element
  style?: React.CSSProperties
}) {
  return (
    <Card className={className || ''} style={style}>
      {header ? <Card.Header>{header}</Card.Header> : null}

      <Card.Body>
        {title ? (
          <div className="d-flex align-items-center card-title-container">
            <div className="d-flex justify-content-between card-title h5 w-100 m-0">{title}</div>
          </div>
        ) : null}

        {children}
      </Card.Body>
    </Card>
  )
}
